import { render, staticRenderFns } from "./MultipleSelectDropdown.vue?vue&type=template&id=05020488&scoped=true"
import script from "./MultipleSelectDropdown.vue?vue&type=script&lang=js"
export * from "./MultipleSelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelectDropdown.vue?vue&type=style&index=0&id=05020488&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05020488",
  null
  
)

export default component.exports